import { get, post, patch, del } from "@insite/client-framework/Services/ApiService";

export interface AddOrUpdateBranchApiModel {
    id?: string;
    name: string;
    addressLine1: string;
    addressLine2?: string;
    city: string;
    state: string;
    zipCode: string;
}

export interface BrandsSmeModel {
    id: string;
    name: string;
    brandAlias: string;
    imageUrl: string;
}

export interface BrandListModel {
    uri?: string;
    brandModels: BrandsSmeModel[];
    properties?: any;
    pagination?: {
        currentPage: number;
        page: number;
        pageSize: number;
        totalItemCount: number;
        numberOfPages: number;
        prevPageUri?: string;
        nextPageUri?: string;
        pageSizeOptions?: number[];
    };
}

export interface DeleteBrandModel {
    id: string;
    success: boolean;
}

const baseUrl = "/api/v2/centroconnect/sme/admin/smebrands/list";


export function addBrands(model: AddOrUpdateBranchApiModel) {
    return post<AddOrUpdateBranchApiModel, BrandsSmeModel>(baseUrl, model as any);
}

export function getBrandList(page?: number, pageSize?: number, query?: string) {
    const params = new URLSearchParams();
    if (page !== undefined) params.append("page", page.toString());
    if (pageSize !== undefined) params.append("pageSize", pageSize.toString());
    if (query !== undefined && query.trim()) params.append("query", query.trim());
    const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
    return get<BrandListModel>(url);
}


export function getBrandListById(brandId: string) {
    return get<BrandsSmeModel>(`${baseUrl}/${brandId}`);
}

// export function updateBrands(model: AddOrUpdateBranchApiModel) {
//     return patch<any>(baseUrl, model as any) as Promise<BrandsModel>;
// }

// export function deleteBrands(branchId: string) {
//     return del(`${baseUrl}/${branchId}`) as Promise<void>;
// }
